// extracted by mini-css-extract-plugin
module.exports = {"NoDataSadFace":"NoDataSadFace_NoDataSadFace__Xfei6"};